/**
 * Кросс-хостовый контракт интеграции микрофронтенда ad-banner-frontend.
 * Значения совпадают во всех хостах (frontend-mainpage, mobile-mainpage-frontend, frontend-serp),
 * менять их нельзя.
 */
export const AD_BANNER_MF_NAME = 'ad-banner-frontend';

/** Глобальный конфиг-флаг включения микрофронтенда. */
export const AD_BANNER_MF_ENABLED_KEY = 'MarTech.AdBannerMicrofrontend.Enabled';

/** Ключ настройки, под которым лежит сырой IMicrofrontendManifest (на ноде и в браузере). */
export const AD_BANNER_MF_MANIFEST_SETTING_KEY = 'adBannerMicrofrontendManifest';
